import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form } from 'antd'
import { requiredRule } from '../../../utils/rules'
import { Localizable } from '../../localizable/Localizable'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Localizable.Input name="name" rules={[requiredRule()]} label={'Name'} />
    </Form>
  )
}

export default Create
